import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'matchesStatus'
})
export class MathcesStatusPipe implements PipeTransform {
    transform(items: Array<any>, status: string): Array<any> {
        return items.filter(item => item.Status === status);
    }
}